import { TimeQuestionConfig, TimeType } from '@gripp/shared-logic';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { InlineFields, LabelledSlot } from '../components/printPrimitives';
import { PRINT_SHEET_CLASS as C } from '../printStyles';
import { RoutinePrintQuestion } from './types';

/**
 * Pre-drawn separators rather than one long rule: a writer fills `__:__ AM/PM`
 * without being told what shape the answer takes.
 */
const TimeMask: FC = () => (
  <div className={`${C}__rule`} style={{ display: 'flex', alignItems: 'flex-end', gap: 6 }}>
    <span style={{ flex: '1 1 0' }} />
    <span className={`${C}__optionText`}>:</span>
    <span style={{ flex: '1 1 0' }} />
    <span className={`${C}__optionText`}>AM / PM</span>
  </div>
);

const DateMask: FC = () => (
  <div className={`${C}__rule`} style={{ display: 'flex', alignItems: 'flex-end', gap: 6 }}>
    <span style={{ flex: '1 1 0' }} />
    <span className={`${C}__optionText`}>/</span>
    <span style={{ flex: '1 1 0' }} />
    <span className={`${C}__optionText`}>/</span>
    <span style={{ flex: '1.6 1 0' }} />
  </div>
);

export const TimePrintQuestion: RoutinePrintQuestion = ({ config }) => {
  const time = config as TimeQuestionConfig;
  const { t } = useTranslation();

  if (time.timeType === TimeType.DateOnly) {
    return (
      <InlineFields>
        <LabelledSlot label={t('routine.print.date', 'Date')} grow={2}>
          <DateMask />
        </LabelledSlot>
        <span style={{ flex: '2 1 0' }} />
      </InlineFields>
    );
  }

  if (time.timeType === TimeType.StartEndTimes) {
    return (
      <InlineFields>
        <LabelledSlot label={t('routine.print.startTime', 'Start')} grow={2}>
          <TimeMask />
        </LabelledSlot>
        <LabelledSlot label={t('routine.print.endTime', 'End')} grow={2}>
          <TimeMask />
        </LabelledSlot>
      </InlineFields>
    );
  }

  if (time.timeType === TimeType.TimeAndDate) {
    return (
      <InlineFields>
        <LabelledSlot label={t('routine.print.date', 'Date')} grow={2}>
          <DateMask />
        </LabelledSlot>
        <LabelledSlot label={t('routine.print.time', 'Time')} grow={2}>
          <TimeMask />
        </LabelledSlot>
      </InlineFields>
    );
  }

  return (
    <InlineFields>
      <LabelledSlot label={t('routine.print.time', 'Time')} grow={2}>
        <TimeMask />
      </LabelledSlot>
      <span style={{ flex: '2 1 0' }} />
    </InlineFields>
  );
};
